export { default as FloatSpotlight } from './FloatSpotlight';